
var VispyCanvas = function ($el) {
    this.$el = $el;
};

module.exports = VispyCanvas;
